import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import { getDetailData } from "../../models/domainModel";
import {fetchDomainById} from "../../store/domain-slice";

const DomainDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchDomainById({id:params.domainId}));
    }, [dispatch, params.domainId,]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.domain);


    const item = items.find(item => item.id === params.domainId);
    const detailData = getDetailData({ item });

    return (
        <>
            <SubHeader title="Domain Details">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />}
            </div>
        </>
    );
};

export default DomainDetail;
